/**
 * Used purely to help compiler check for exhaustiveness in switch statements,
 * will never execute. See https://stackoverflow.com/a/39419171.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function assertUnreachable(x: never): never {
  throw Error("This code should be unreachable");
}

const compactNumberFormatter = new Intl.NumberFormat("en-US", {
  notation: "compact",
  compactDisplay: "short",
  maximumFractionDigits: 1,
});

export function formatCompactNumber(value: number): string {
  if (!Number.isFinite(value)) {
    return "0";
  }

  const normalizedValue = Math.max(0, Math.round(value));
  if (normalizedValue < 1000) {
    return String(normalizedValue);
  }

  return compactNumberFormatter
    .format(normalizedValue)
    .replace(/[A-Z]/g, (suffix) => suffix.toLowerCase());
}
